var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPredictiveScoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2666_363)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6939 19.261L21.2979 16.865C20.8189 16.386 19.9999 16.725 19.9999 17.402V18.826C19.2039 18.344 18.4069 16.862 17.7439 15.617C16.7539 13.757 15.8189 12 14.2499 12C12.6809 12 11.7459 13.757 10.7559 15.617L10.7549 15.6188C9.95308 17.1255 8.95549 19 7.99987 19H7.23987C6.35338 18.7961 5.97114 18.6064 5.40487 18.192C5.15487 17.858 5.00087 17.448 5.00087 16.999V4H6.55987C7.23687 4 7.57587 3.181 7.09687 2.702L4.69987 0.306C4.29187 -0.102 3.62987 -0.102 3.22187 0.306L0.825866 2.702C0.346866 3.181 0.685866 4 1.36287 4H2.99887V17C2.99887 19.206 4.79287 21 6.99887 21H19.9989V22.598C19.9989 23.275 20.8179 23.614 21.2969 23.135L23.6929 20.739C24.1009 20.331 24.1019 19.669 23.6939 19.261ZM12.5241 16.5519L12.5219 16.556C12.0809 17.383 11.6139 18.249 11.0799 18.999H17.4209C16.8869 18.249 16.4189 17.384 15.9789 16.556L15.9767 16.552C15.5162 15.6871 14.6632 14.0849 14.2429 13.999C13.8375 14.0849 12.9846 15.6869 12.5241 16.5519Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 18.5971C8.57822 14.4016 11 5.72034 13.0002 5.72052C15.5224 5.72075 16.637 8.66324 17.0002 9.72064",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2666_363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictiveScoring);
export default __webpack_public_path__ + "static/media/PredictiveScoring.6e73718fb0da2acc98c75e71bc73927d.svg";
export { ForwardRef as ReactComponent };